import { polygon as viemPolygon } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const polygon = {
  displayName: 'Polygon',
  runtime: 'evm',
  viemChain: viemPolygon,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 7,

  decoration: {
    color: '#9430CF',
    contrastColor: getContrastColor('#9430CF'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'matic',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://polygonscan.com',
        token: 'https://polygonscan.com/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    debridge: {
      chainKey: '137',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'POL' },
    stargate: { chainKey: 'polygon' },
    across: { chainKey: 'polygon' },
    xswap: { chainKey: '137' },
    okx: { chainKey: '137' },
    kyberswap: { chainKey: 'polygon' },
    houdini: { chainKey: 'MATIC' },
  }),
  services: defaultServices({
    codex: {
      networkId: 137,
      nativeLiquidityAddress: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', // WPOL
    },
    defiLlama: { chainKeys: ['polygon'] },
    trm: { chainKey: 'polygon' },
    zerion: { chainKey: 'polygon' },
    coingecko: {
      networkId: 'polygon-pos',
      platformId: 'polygon-pos',
    },
    coingeckoDex: {
      networkId: 'polygon_pos',
    },
    qnStreams: {
      networkKey: 'polygon-mainnet',
    },
    safe: { shortName: 'pol' },
    alchemy: { chainSlug: 'polygon-mainnet' },
    pimlico: { chainSlug: 'polygon' },
  }),

  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'evm', true>;
